import { render, staticRenderFns } from "./NewPatient.vue?vue&type=template&id=5abd4b12&scoped=true&"
import script from "./NewPatient.vue?vue&type=script&lang=js&"
export * from "./NewPatient.vue?vue&type=script&lang=js&"
import style0 from "./NewPatient.vue?vue&type=style&index=0&id=5abd4b12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5abd4b12",
  null
  
)

export default component.exports